import { ComponentType } from '@angular/cdk/portal';
import { AttachmentDeadlineDialogComponent } from './attachment-deadline-dialog/attachment-deadline-dialog.component';
import { AttachmentNoDeadlineDialogComponent } from './attachment-no-deadline-dialog/attachment-no-deadline-dialog.component';
import { CaseAssignedToBailiffDialogComponent } from './case-assigned-to-bailiff-dialog/case-assigned-to-bailiff-dialog.component';
import { ClientUploadContractDialogComponent } from './client-upload-contract-dialog/client-upload-contract-dialog.component';
import { CloseCaseComponent } from './close-case/close-case.component';
import { DebtorIndDataDialogComponent } from './debtor-ind-data-dialog/debtor-ind-data-dialog.component';
import { DiscardCaseComponent } from './discard-case/discard-case.component';
import { EnforcementExternalIdReceivedDialogComponent } from './enforcement-external-id-received-dialog/enforcement-external-id-received-dialog.component';
import { DebtorStatementDialogComponent } from './debtor-statement-dialog/debtor-statement-dialog.component';
import { HardPerformanceClaimResponseComponent } from './hard-performance-claim-response/hard-performance-claim-response.component';
import { GenerateAttorneyDataDialogComponent } from './generate-attorney-data-dialog/generate-attorney-data-dialog.component';
import { HardLegallyBindingDialogComponent } from './hard-legally-binding-dialog/hard-legally-binding-dialog.component';
import { HardPaymentPlanApproveDialogComponent } from './hard-payment-plan-approve-dialog/hard-payment-plan-approve-dialog.component';
import { InfoNotificationDialogComponent } from './info-notification-dialog/info-notification-dialog.component';
import { CofaceManualPaymentComponent } from './coface-manual-payment/coface-manual-payment.component';
import { CreateCofaceCaseDialogComponent } from './create-coface-case-dialog/create-coface-case-dialog.component';
import { ManualPaymentComponent } from './manual-payment/manual-payment.component';
import { MissedInstallmentReportComponent } from './missed-installment-report/missed-installment-report.component';
import { MissingDataGeneralComponent } from './missing-data-general/missing-data-general.component';
import { BookBailiffFeePaidDialogComponent } from './book-bailiff-fee-paid-dialog/book-bailiff-fee-paid-dialog.component';
import { NoAttachmentNoDeadlineDialogComponent } from './no-attachment-no-deadline-dialog/no-attachment-no-deadline-dialog.component';
import { OrderForPaymentExternalIdReceivedDialogComponent } from './order-for-payment-external-id-received-dialog/order-for-payment-external-id-received-dialog.component';
import { RealEstateExecutionComponent } from './real-estate-execution/real-estate-execution.component';
import { RequestBailiffDeliveryDialogComponent } from './request-bailiff-delivery-dialog/request-bailiff-delivery-dialog.component';
import { RequestEnforcementFeeAdvancePaymentDialogComponent } from './request-enforcement-fee-advance-payment-dialog/request-enforcement-fee-advance-payment-dialog.component';
import { RefundDialogComponent } from './refund-dialog/refund-dialog.component';
import { StartExecutionDialogComponent } from './start-execution-dialog/start-execution-dialog.component';
import { StartFeesPaidDialogComponent } from './start-fees-paid-dialog/start-fees-paid-dialog.component';
import { StartWithCreditDialogComponent } from './start-with-credit-dialog/start-with-credit-dialog.component';
import { CustomMessageResponseDialogComponent } from './custom-message-response-dialog/custom-message-response-dialog.component';
import { SendCustomMessageDialogComponent } from './send-custom-message-dialog/send-custom-message-dialog.component';

export const dialogNames = [
  'ATTORNEY-ATTACHMENT_DEADLINE',
  'ATTORNEY-ATTACHMENT_NO_DEADLINE',
  'ATTORNEY-NO_ATTACHMENT_NO_DEADLINE',
  'BOOK-BAILIFF-FEE-PAID',
  'CASE-ASSIGNED-TO-BAILIFF',
  'CLIENT-UPLOAD-CONTRACT',
  'DEBTOR-IND-DATA',
  'DEBTOR_STATEMENT',
  'DIALOG_23-MISSED_INSTALLMENT',
  'HARD_PERFORMANCE_CLAIM_RESPONSE',
  'DIALOG_4-ACTION-DISCARD',
  'DIALOG_5-ACTION_CANCEL',
  'COFACE-CREATE-CASE',
  'COFACE-PAYMENT-STAGE',
  'DIALOG_8-PAYMENT-STAGE',
  'DIALOG_9-PAYMENT-STAGE-WHILE-AT-ATTORNEY',
  'GENERATE-ATTORNEY-DATA',
  'HARD-PAYMENT-PLAN-APPROVE',
  'HIANYPOTLAS-GENERAL',
  'REQUEST-BAILIFF-OR-ADD-ADDRESS',
  'START-HARD_2',
  'SUBMISSION_REGISTRATION_OF_RIGHT_OF_ENFORCEMENT',
  'START-WITH-CREDITS',
  'START-FEES-PAID',
  'HARD-LEGALLY-BINDING',
  'INFO-NOTIFICATION',
  'ORDER-FOR-PAYMENT-EXTERNAL-ID-RECIEVED',
  'ENFORCEMENT-EXTERNAL-ID-RECIEVED',
  'REQUEST-ENFORCEMENT-FEE-ADVANCE-PAYMENT',
  'REFUND',
  'CUSTOM-MESSAGE-RESPONSE',
  'CUSTOM-MESSAGE-SEND',
] as const;
export type DialogName = typeof dialogNames[number];

export function getDialogComponent(name: DialogName): ComponentType<any> {
  switch (name) {
    case 'ATTORNEY-ATTACHMENT_DEADLINE': return AttachmentDeadlineDialogComponent;
    case 'ATTORNEY-ATTACHMENT_NO_DEADLINE': return AttachmentNoDeadlineDialogComponent;
    case 'ATTORNEY-NO_ATTACHMENT_NO_DEADLINE': return NoAttachmentNoDeadlineDialogComponent;
    case 'BOOK-BAILIFF-FEE-PAID': return BookBailiffFeePaidDialogComponent;
    case 'CASE-ASSIGNED-TO-BAILIFF': return CaseAssignedToBailiffDialogComponent;
    case 'CLIENT-UPLOAD-CONTRACT': return ClientUploadContractDialogComponent;
    case 'DEBTOR-IND-DATA': return DebtorIndDataDialogComponent;
    case 'DEBTOR_STATEMENT': return DebtorStatementDialogComponent;
    case 'DIALOG_23-MISSED_INSTALLMENT': return MissedInstallmentReportComponent;
    case 'HARD_PERFORMANCE_CLAIM_RESPONSE': return HardPerformanceClaimResponseComponent;
    case 'DIALOG_4-ACTION-DISCARD': return DiscardCaseComponent;
    case 'DIALOG_5-ACTION_CANCEL': return CloseCaseComponent;
    case 'COFACE-CREATE-CASE': return CreateCofaceCaseDialogComponent;
    case 'COFACE-PAYMENT-STAGE': return CofaceManualPaymentComponent;
    case 'DIALOG_8-PAYMENT-STAGE': return ManualPaymentComponent;
    case 'DIALOG_9-PAYMENT-STAGE-WHILE-AT-ATTORNEY': return ManualPaymentComponent;
    case 'GENERATE-ATTORNEY-DATA': return GenerateAttorneyDataDialogComponent;
    case 'HARD-PAYMENT-PLAN-APPROVE': return HardPaymentPlanApproveDialogComponent;
    case 'HIANYPOTLAS-GENERAL': return MissingDataGeneralComponent;
    case 'REQUEST-BAILIFF-OR-ADD-ADDRESS': return RequestBailiffDeliveryDialogComponent;
    case 'START-HARD_2': return StartExecutionDialogComponent;
    case 'SUBMISSION_REGISTRATION_OF_RIGHT_OF_ENFORCEMENT': return RealEstateExecutionComponent;
    case 'START-WITH-CREDITS': return StartWithCreditDialogComponent;
    case 'START-FEES-PAID': return StartFeesPaidDialogComponent;
    case 'HARD-LEGALLY-BINDING': return HardLegallyBindingDialogComponent;
    case 'INFO-NOTIFICATION': return InfoNotificationDialogComponent;
    case 'ORDER-FOR-PAYMENT-EXTERNAL-ID-RECIEVED': return OrderForPaymentExternalIdReceivedDialogComponent;
    case 'ENFORCEMENT-EXTERNAL-ID-RECIEVED': return EnforcementExternalIdReceivedDialogComponent;
    case 'REQUEST-ENFORCEMENT-FEE-ADVANCE-PAYMENT': return RequestEnforcementFeeAdvancePaymentDialogComponent;
    case 'REFUND': return RefundDialogComponent;
    case 'CUSTOM-MESSAGE-RESPONSE': return CustomMessageResponseDialogComponent;
    case 'CUSTOM-MESSAGE-SEND': return SendCustomMessageDialogComponent;
    default: throw new Error('Unknown component');
  };
}
